
@if(indice_marche$ | async) {
    <nav class="emp-nav">
        <div class="sidebar-sticky-header">
            <h2 class="sidebar-title">{{ 'sidebar.catalogo' | T}}</h2>
        </div>
        <ul class="nav-menu">
            <!-------------------------------------------------- INDICE MARCHE ------------------------------------------------>
            @for (indice of indice_marche$ | async; track indice.idindice; let idx = $index) {
                <!-- PRIMO LIVELLO -->
                <li class="nav-item" (click)="handleSubmenuClick($event)">
                    <a href="#" class="nav-link">
                        <span>
                            <img class="img_marca" src="images/sidebar_image/marca_{{indice.idindice}}.jpg" loading="lazy" decoding="async">
                            <span>{{ indice.titolo }}</span>
                        </span>
                        @if(indice.children && indice.children.length > 0) {
                            <span class="arrow">▶</span>
                        }
                    </a>
                    @if(indice.children && indice.children.length > 0) {
                        <ul class="submenu">
                            <!-- PRIMO LIVELLO:TUTTI-->
                            <li class="submenu-item">
                                <a href="#" [routerLink]="['/c/i', indice.seoname, indice.idindice]" class="nav-link" (click)="voidClick($event)">
                                    <span class="fw-bold">{{ 'visualizza_tutti' | T }}</span>
                                </a>
                            </li>
                            @for(indice_figlio of indice.children; track indice_figlio.idindice; let idx_figlio = $index) {
                                <!-- SECONDO LIVELLO -->
                                <li class="submenu-item" (click)="handleSubmenuClick($event)">
                                        @if(indice_figlio.children && indice_figlio.children.length > 0) {
                                            <!-- NEL CASO ABBIA FIGLI NON HA IL LINK XE CI SARA LA VOCE visualizza tutti-->
                                            <a href="#" class="nav-link">
                                                <span [innerHTML]="indice_figlio.titolo"></span>
                                                <span class="arrow">▶</span>
                                            </a>
                                        }
                                        @else {
                                            <!-- NEL CASO NON ABBIA FIGLI HA LINK-->
                                            <a href="#" [routerLink]="['/c/i', indice.seoname, indice_figlio.seoname, indice_figlio.idindice]" class="nav-link" (click)="voidClick($event)">
                                                <span [innerHTML]="indice_figlio.titolo"></span>
                                            </a>
                                        }
                                    @if(indice_figlio.children && indice_figlio.children.length > 0) {
                                        <ul class="sub-submenu">
                                            <!-- SECONDO LIVELLO:TUTTI -->
                                            <li class="sub-submenu-item">
                                                <a href="#" [routerLink]="['/c/i', indice.seoname, indice_figlio.seoname, indice_figlio.idindice]" class="nav-link" (click)="voidClick($event)">
                                                    <span class="fw-bold">{{ 'visualizza_tutti' | T }}</span>
                                                </a>
                                            </li>
                                            @for(indice_nipote of indice_figlio.children; track indice_nipote.idindice; let idx_nipote = $index) {
                                                <!-- TERZO LIVELLO -->
                                                @if(indice_nipote.children && indice_nipote.children.length > 0) {
                                                    <li class="sub-submenu-item" (click)="handleSubmenuClick($event)">
                                                        <!-- NEL CASO ABBIA FIGLI NON HA IL LINK XE CI SARA LA VOCE visualizza tutti-->
                                                        <a href="#" class="nav-link">
                                                            <span [innerHTML]="indice_nipote.titolo"></span>
                                                            <span class="arrow">▶</span>
                                                        </a>
                                                        <ul class="sub-sub-submenu">
                                                            <!-- TERZO LIVELLO:TUTTI -->
                                                            <li class="sub-sub-submenu-item">
                                                                <a href="#" [routerLink]="['/c/i', indice.seoname, indice_figlio.seoname, indice_nipote.seoname, indice_nipote.idindice]" class="nav-link" (click)="voidClick($event)">
                                                                    <span class="fw-bold">{{ 'visualizza_tutti' | T }}</span>
                                                                </a>
                                                            </li>
                                                            @for(indice_pronipote of indice_nipote.children; track indice_pronipote.idindice) {
                                                                <!-- QUARTO LIVELLO: le route supportano max 3 seoname → ultimi 3 (come breadcrumb) -->
                                                                <li class="sub-sub-submenu-item">
                                                                    <a href="#" [routerLink]="['/c/i', indice_figlio.seoname, indice_nipote.seoname, indice_pronipote.seoname, indice_pronipote.idindice]" class="nav-link" (click)="voidClick($event)"><span [innerHTML]="indice_pronipote.titolo"></span></a>
                                                                </li>
                                                            }
                                                        </ul>
                                                    </li>
                                                }
                                                @else {
                                                    <li class="sub-submenu-item">
                                                        <a href="#" [routerLink]="['/c/i', indice.seoname, indice_figlio.seoname, indice_nipote.seoname, indice_nipote.idindice]" class="nav-link" (click)="voidClick($event)"><span [innerHTML]="indice_nipote.titolo"></span></a>
                                                    </li>
                                                }
                                            }
                                        </ul>
                                    }
                                </li>
                            }
                        </ul>
                    }
                </li>
            }
            
            <!-------------------------------------------------- INDICE ricambi ------------------------------------------------>
            @if(exists_ricambi) {
                    <li class="nav-item" (click)="handleSubmenuClick($event)">
                        <a href="#" class="nav-link">
                            <span>
                                <fa-icon class="fa-menu-icon" [icon]="faRicambi"></fa-icon>
                                {{ 'sidebar.ricambi' | T }}
                            </span>
                            <span class="arrow">▶</span>
                        </a>
                            <ul class="submenu">
                                @for (indice of indice_ricambi$ | async; track indice.idindice; let idx = $index) {
                                    <li class="submenu-item">
                                        <a href="#" [routerLink]="['/c/i', indice.seoname, indice.idindice]" class="nav-link" (click)="voidClick($event)">
                                            <span>
                                                <img class="img_marca" src="images/sidebar_image/marca_{{indice.idindice}}.jpg" loading="lazy" decoding="async">
                                                {{ indice.titolo }}
                                            </span>
                                        </a>
                                    </li>
                                }
                            </ul>
                    </li>
            }

            <!-------------------------------------------------- STATIC MENU ------------------------------------------------>
            <h2 class="sidebar-title">{{ 'sidebar.pagineutili' | T | uppercase}}</h2>
            @if(show_blog_item){
                <li class="nav-item"><a routerLink="/blog" class="nav-link" (click)="voidClick($event)"><span>BLOG</span></a></li>
            }
            <li class="nav-item"><a class="nav-link" routerLink="/{{ 'ROUTE.chi-siamo' | T }}" (click)="voidClick($event)">{{ "sidebar.chisiamo" | T | uppercase}}</a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/{{ 'ROUTE.dove-siamo' | T }}" (click)="voidClick($event)">{{ "sidebar.dovesiamo" | T | uppercase}}</a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/{{ 'ROUTE.spedizioni-e-pagamenti' | T }}" (click)="voidClick($event)">{{ "sidebar.spedizionepagamenti" | T | uppercase }}</a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/{{ 'ROUTE.dati-azienda' | T }}" (click)="voidClick($event)">{{ "sidebar.datiazienda" | T |uppercase }}</a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/{{ 'ROUTE.negozi' | T }}" (click)="voidClick($event)"><span><fa-icon class="fa-nostri-store" [icon]="faNostriStore"></fa-icon>{{ "headertop.ourstore" | T |uppercase }}</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/privacy" (click)="voidClick($event)">PRIVACY</a></li>
            
        </ul>
    </nav>
}